module.exports = {"menu":[{"title":"Services","link":"#"},{"title":"Contact","link":"#"}]}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/rhodes.json
// module id = 200
// module chunks = 0